import styled from 'styled-components'

import { CardStyled } from './CardStyled'

export const FlatBorderCardStyled = styled(CardStyled)`
  box-shadow: none;
  border: 1px solid ${(props) => props.theme.colors.content.border};
`

FlatBorderCardStyled.displayName = 'FlatBorderCardStyled'
